import { createApiInstance } from './config'

const api = createApiInstance()

/**
 * 挂机地图下拉选项（表 adventure_hang_map_options）
 * @param {string} game 默认 冒险岛枫星
 */
export const getAdventureHangMapOptions = (game = '冒险岛枫星') => {
  return api.get('/adventure-hang-maps', { params: { game } })
}
